import type { HTMLAttributes } from "react";
import { cn } from "./cn";

export type CardProps = HTMLAttributes<HTMLDivElement> & { ref?: React.Ref<HTMLDivElement> };

export function Card({ className, children, ...rest }: CardProps) {
  return (
    <div className={cn("rounded-card bg-surface shadow-card", className)} {...rest}>
      {children}
    </div>
  );
}
